/** Retain the element authorized by the button tap across the Idea refresh. */
export function createBriefStartAudioPrimer({ prime, isCurrent, discard }) {
  let pending = null;
  return {
    prime() {
      const player = prime();
      pending = player;
      return () => {
        if (pending !== player) return;
        pending = null;
        if (isCurrent(player)) discard(player);
      };
    },
    acquire(create) {
      const player = pending;
      pending = null;
      return player && isCurrent(player) ? player : create();
    },
  };
}
